import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import {
  FaTachometerAlt,
  FaPlug,
  FaUser,
  FaClock,
  FaVideo,
  FaBars,
  FaCalendarCheck,
  FaCog,
  FaFile,
  FaDollarSign,
} from "react-icons/fa";
import React, { useEffect, useState } from "react";

const CounsellorSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        style={{
          width: collapsed ? "80px" : "200px",
          position: isMobile ? "fixed" : "relative",
          left: isMobileOpen ? "0" : isMobile ? "-250px" : "0",
          height: "100vh",
          backgroundColor: "#fff",
          color: "#000",
          transition: "width 0.5s ease, transform 0.5s ease",
          transform: isMobile
            ? isMobileOpen
              ? "translateX(0)"
              : "translateX(-200px)"
            : "translateX(0)",
          zIndex: isMobileOpen ? 999 : "auto",
          boxShadow: isMobileOpen ? "2px 0 5px rgba(0,0,0,0.2)" : "none",
          overflow: "hidden", // to avoid content flicker
        }}
      >
        <Menu>
          {/* Sidebar Header with Toggle Button */}
          <div className="sidebar-header">
            <div
              style={{
                display: "flex",
                justifyContent: collapsed ? "center" : "space-between",
                alignItems: "center",
                padding: "12px",
              }}
            >
              <FaBars
                className="toggle-btn"
                onClick={handleToggle}
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#000",
                }}
              />
              {!collapsed && !isMobileOpen && (
                <span style={{ marginLeft: "10px", color: "black" }}>
                  Appointments
                </span>
              )}
            </div>
          </div>

          {/* Menu Items */}
          <MenuItem
            component={<Link to="/counsellor/dashboard" />}
            icon={<FaTachometerAlt />}
          >
            Dashboard
          </MenuItem>
          <MenuItem
            component={<Link to="/counsellor/appointments" />}
            icon={<FaCalendarCheck />}
          >
            Appointments
          </MenuItem>
          <MenuItem
            component={<Link to="/counsellor/availability" />}
            icon={<FaClock />}
          >
            Availability
          </MenuItem>
          <MenuItem
            component={<Link to="/counsellor/integrations" />}
            icon={<FaPlug />}
          >
            Integrations
          </MenuItem>

          <MenuItem
            component={<Link to="/counsellor/CounsellorFees" />}
            icon={<FaDollarSign />}
          >
            Set Fees
          </MenuItem>

          {/* <MenuItem
            component={<Link to="/counsellor/invoices" />}
            icon={<FaFile />}
          >
            Invoices
          </MenuItem> */}
          <MenuItem
            component={<Link to="/counsellor/profile" />}
            icon={<FaUser />}
          >
            Profile
          </MenuItem>
          {/* <MenuItem
            component={<Link to="/counsellor/zoom" />}
            icon={<FaVideo />}
          >
            Zoom
          </MenuItem> */}
          {/* <MenuItem
            component={<Link to="/counsellor/settings" />}
            icon={<FaCog />}
          >
            Settings
          </MenuItem> */}
        </Menu>
      </Sidebar>
    </>
  );
};

export default CounsellorSidebar;
